import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

// Get all feedbacks
export const getFeedbacks = () => apiClient.get(ENDPOINTS.FEEDBACK.BASE);

// Get feedback by ID
export const getFeedbackById = (feedbackId) => apiClient.get(ENDPOINTS.FEEDBACK.BY_ID(feedbackId));

// Get feedbacks by exam
export const getFeedbacksByExam = (examId) => apiClient.get(ENDPOINTS.FEEDBACK.BY_EXAM(examId));

// Create feedback (for users)
export const createFeedback = (data) => apiClient.post(ENDPOINTS.FEEDBACK.BASE, data);

// Update feedback
export const updateFeedback = (feedbackId, data) => apiClient.put(ENDPOINTS.FEEDBACK.BY_ID(feedbackId), data);

// Delete feedback
export const deleteFeedback = (feedbackId) => apiClient.delete(ENDPOINTS.FEEDBACK.BY_ID(feedbackId));
